export default "assets/images/c49f2344772e33256ba24d64b59b20d1.png";